import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { stringify } from 'query-string';

import ScrollToTopOnMount from 'cityads-v3/containers/misc/ScrollToTopOnMount';
import { getNewsFields } from 'cityads-v3/utils/newsUtils';

import { getConversionsData, getTopWMsData, getTopOffersData, getNewAndPopOffersData, getTopNewsData } from 'cityads-v3/actions/home';

import { ALLOWED_PATHS as STARTWORK_PATHS } from 'cityads-v3/components/Buttons/StartWorkButton';

import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import { tArray } from 'cityads-v3/i18n/utils';

import Balaclava from 'cityads-v3/components/Balaclava/Balaclava'
import ClickableCardWithPopup from 'cityads-v3/components/CardWithPopup/ClickableCardWithPopup'
import HomeTabPanel from 'cityads-v3/components/TabPanel/TabPanel'
import HomeBanner from 'cityads-v3/components/Home/HomeBanner'
import HomeOfferCard from 'cityads-v3/components/Home/OfferCard'
import HomeWidgetGraph from 'cityads-v3/components/Home/Widgets/Graph'
import HomeWidgetTable from 'cityads-v3/components/Home/Widgets/Table'
import HomeWidgetLoading from 'cityads-v3/components/Home/Widgets/Loading'
import ToolsCarousel, { ALLOWED_PATHS as TOOLS_PATHS} from 'cityads-v3/components/Carousel/ToolsCarousel'

import classNames from './Home.scss';

export const ALLOWED_PATHS = [
  ...STARTWORK_PATHS,
  ...TOOLS_PATHS,
  'last_news',
  'power_of_cpa',
  'earn',
  'auth',
  'lost'
];

@connect(
  state => ({
    toolsCarouselItems: state.home.toolsCarouselItems,
    tabItems: state.home.tabItems,
    language: state.language.language,

    recentConversionsStat: state.home.recentConversionsStat,
    isLoadingConversionsData: state.home.isLoadingConversionsData,
    isConversionsDataLoaded: state.home.isConversionsDataLoaded,

    topWMs: state.home.topWMs,
    isLoadingTopWMsData: state.home.isLoadingTopWMsData,
    isTopWMsDataLoaded: state.home.isTopWMsDataLoaded,

    topOffers: state.home.topOffers,
    isLoadingTopOffersData: state.home.isLoadingTopOffersData,
    isTopOffersDataLoaded: state.home.isTopOffersDataLoaded,

    newestOffer: state.home.mainOffers.newest,
    mostPopularOffer: state.home.mainOffers.mostPopular,
    isLoadingMainOffersData: state.home.isLoadingMainOffersData,
    isMainOffersDataLoaded: state.home.isMainOffersDataLoaded,

    mainNews: state.home.mainNews,
    isLoadingMainNewsData: state.home.isLoadingMainNewsData,
    isMainNewsDataLoaded: state.home.isMainNewsDataLoaded,
  }),
  dispatch => bindActionCreators({
    getConversionsData, getTopWMsData, getTopOffersData, getNewAndPopOffersData, getTopNewsData,
  }, dispatch)
)
@withTranslation(['main'], { i18n, wait: !!window })
export default class Home extends Component {
  static propTypes = {
    history: PropTypes.any,
    toolsCarouselItems: PropTypes.array,
    tabItems: PropTypes.array,
    recentConversionsStat: PropTypes.array,
    isLoadingConversionsData: PropTypes.bool,
    isConversionsDataLoaded: PropTypes.bool,
    isTopWMsDataLoaded: PropTypes.bool,
    isLoadingTopWMsData: PropTypes.bool,
    language: PropTypes.string
  }

  state = {
    isForAdvertisersCollapsed: true,
    advertisersAnchorEl: null,
  }

  toggleCollapseAdvertiser = (event) => {
    this.setState({
      isForAdvertisersCollapsed: !this.state.isForAdvertisersCollapsed,
    });
  }

  componentDidMount() {
    if (!this.props.isConversionsDataLoaded && !this.props.isLoadingConversionsData) {
      this.props.getConversionsData();
    }

    if (!this.props.isTopWMsDataLoaded && !this.props.isLoadingTopWMsData) {
      this.props.getTopWMsData();
    }

    if (!this.props.isTopOffersDataLoaded && !this.props.isLoadingTopOffersData) {
      this.props.getTopOffersData();
    }

    if (!this.props.isMainOffersDataLoaded && !this.props.isLoadingMainOffersData) {
      this.props.getNewAndPopOffersData();
    }

    if (!this.props.isMainNewsDataLoaded && !this.props.isLoadingMainNewsData) {
      this.props.getTopNewsData();
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.language !== this.props.language) {
      this.props.getTopNewsData();
      this.props.getNewAndPopOffersData();
    }
  }

  getTabItemLink({ category_id, direction_and_platform }) {
    const filter = {
      category_id,
      direction_and_platform,
    };

    return '/publisher/offers?' + stringify(filter, { 'arrayFormat': 'comma' });
  }

  render() {
    const { t, match, mainNews, language } = this.props;

    let subpagePrefix = match.path.split(':')[0];
    subpagePrefix = subpagePrefix.substr(0, subpagePrefix.length - 1);

    const leftCards = [
      ...(mainNews || !this.props.isMainNewsDataLoaded ? [{
        attrs: {id: 'homeLastNews'},
        dataReady: this.props.isMainNewsDataLoaded,
        ...getNewsFields(
          mainNews,
          t,
          '/main/news/all/' + (mainNews ? mainNews.id : '')
        ),
        moreLink: subpagePrefix + '/last_news',
        lessLink: subpagePrefix,
        actions: language === 'ru' ? [
          {
            title: t('all_news'),
            link : '/main/news/all',
            onClick: (data, evt) => {
              evt.stopPropagation(); // чтобы не попапилась карточка
            }
          }
        ] : [],
      }] : []),
      {
        subtitle : t('card2.subtitle'),
        graphData: this.props.recentConversionsStat || [],
        dataReady: this.props.isConversionsDataLoaded,
      },
      {
        title: t('card5.title'),
        subtitle: t('card5.subtitle'),
        image: require('./img/geo.svg'),
        actions: [
          {
            title: t('learn_more'),
            link : '/main/about/contacts',
          }
        ],
        text: t('card5.text'),
        classes: {
          root: classNames.geoCard,
        },
        cardHeaderClasses: {
          root: classNames.geoHeader,
          title: classNames.geoTitle,
          subheader: classNames.geoSubtitle,
        }
      },
      {
        attrs       : {id: 'homeEarnCard'},
        title       : t('card1.title'),
        subtitle    : t('card1.subtitle'),
        image       : require('./img/publisher/money-magnet-compressor.jpg'),
        moreLink    : subpagePrefix + '/earn',
        lessLink    : subpagePrefix,
        articleClass: 'PublisherMore',
        text        : t('card1.text')
      },
      /*{
        title: 'Top offers',
        subtitle: 'Are you ready to join?',
        tableColumns: [
          { name: 'number', title: '#', type: 'number', precision: 0},
          { name: 'name', title: 'Offer', type: 'string'},
          { name: '7depc', title: '7D EPC', type: 'number', precision: 0},
          { name: '3mepc', title: '3M EPC', type: 'number', precision: 0},
        ],
        tableData: this.props.topOffers ? this.props.topOffers.map((offerData, index) => ({
          number: index + 1,
          ...offerData
        })) : [],
        dataReady: this.props.isTopOffersDataLoaded,
      },*/
    ];

    const rightCards = [
      {
        headerTitle: t('ourOffers'),
        headerIcon: 'flag',
        actions: [{
          title: t('allOffers'),
          link: '/publisher/offers',
        }],
        dataReady: this.props.isMainOffersDataLoaded,
        tabs: this.props.isMainOffersDataLoaded ?
          {
            items: [
              ...(this.props.mostPopularOffer ? [t('mostPopular')] : []),
              ...(this.props.newestOffer ? [t('new')] : []),
            ].map((title, index) => ({
              id: index,
              title,
              tabValue: 'homePageOurOffersTab' + index
            }))
          } : null,
        offers: [
          {
            id       : 'homePageMostPopularOffer',
            isPopular: true,
            offer    : this.props.mostPopularOffer
          },
          {
            id   : 'homePageNewestOffer',
            isNew: true,
            offer: this.props.newestOffer
          },
        ]
      }, {
        attrs       : {id: 'homePowerCpaCard'},
        title       : t('card3.title'),
        subtitle    : t('card3.subtitle'),
        image       : require('./img/powercpa-compressor.jpg'),
        text        : t('card3.text'),
        moreLink    : subpagePrefix + '/power_of_cpa',
        lessLink    : subpagePrefix,
        articleClass: 'PowerOfCPA',
      }, {
        title: t('whyCityads.title'),
        subtitle: t('whyCityads.subtitle'),
        image: require('./img/why-compressor.png'),
        actions: [
          {title: t('learn_more'), onClick: this.toggleCollapseAdvertiser}
        ],
        text: (
          <div className={this.state.isForAdvertisersCollapsed ? classNames.collapsibleContentCollapsed : classNames.collapsibleContent}>
            {tArray(t, 'whyCityads.p1', 'p')}
            <ul>
              {tArray(t, 'whyCityads.list1', 'li')}
            </ul>
            <p>
              {t('whyCityads.p2')}
            </p>
            <ul>
              {tArray(t, 'whyCityads.list2', 'li')}
            </ul>
            {tArray(t, 'whyCityads.p3', 'p')}
            <ul>
              {tArray(t, 'whyCityads.list3', 'li')}
            </ul>
            <p>
              {t('whyCityads.p4')}
            </p>
            <ul>
              {tArray(t, 'whyCityads.list4', 'li')}
            </ul>
          </div>
        ),
      }
    ];

    return (
      <div className={classNames.home}>
        <ScrollToTopOnMount/>

        <Helmet
          meta  = {[
            { name: 'description', content: t('head.main.description') },
            { name: 'keywords', content: t('head.main.keywords') },
          ]}
        />
        <Balaclava
          menuValue = {false}
        />

        <HomeBanner />

        <HomeTabPanel
          className = {classNames.tabPanel}
          items     = {this.props.tabItems.map(item => ({
            ...item,
            title: t('tabItems.' + item.translateId + '.title')
          }))}
          getLink   = {this.getTabItemLink}
        />

        <div className={classNames.carouselWrapper}>
          <ToolsCarousel
            className = {classNames.carousel}
            limits    = {{ 0: 1, 544: 2, 800: 4 }}
            items     = {this.props.toolsCarouselItems
              .filter(item => item.orderHome > 0)
              .sort((item1, item2) => item1.orderHome - item2.orderHome)
              .map(item => ({
                ...item,
                title          : t('carouselItems.' + item.translateKey + '.title'),
                children       : t('carouselItems.' + item.translateKey + '.subtitle'),
                moreButtonTitle: t('learn_more'),
              }))}
            moreRoot  = {subpagePrefix}
            lessLink  = {subpagePrefix}
          />
        </div>

        <div className={classNames.cards}>
          <div className="row">
            <div className="col col--sm-6">
              {this.renderCards(leftCards)}
            </div>
            <div className="col col--sm-6">
              {this.renderCards(rightCards)}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCards(cards) {
    return cards.map((card, index) => {
      const { offers, graphData, tableData, tableColumns, dataReady, text } = card;

      let cardText = text;

      if (dataReady || typeof dataReady === 'undefined') {
        if (graphData) {
          cardText = <HomeWidgetGraph
            points = {this.props.recentConversionsStat || []}
          />
        } else if (tableData) {
          cardText = <HomeWidgetTable
            columns = {tableColumns}
            rows    = {tableData}
          />
        } else if (offers && Array.isArray(offers)) {
          cardText = offers
            .filter(offerData => !!offerData.offer)
            .map(({ id, isNew, isPopular, offer: { offer, values } }) => (
              <HomeOfferCard key={offer.id} id={id} offer={offer} stat={values} isNew={isNew} isPopular={isPopular} />
            ))
          ;

          if (cardText.length === 1) {
            cardText = cardText[0];
          }
        }
      } else {
        cardText = <HomeWidgetLoading />
      }

      return <ClickableCardWithPopup
        key={index}
        className={classNames.card}
        moreButtonTitle={this.props.t('learn_more')}
        {...card}
        title={card.title ? <h2 className={classNames.cardHeader}>{card.title}</h2> : null}
      >
        {cardText}
      </ClickableCardWithPopup>
    });
  }

}
